import { render, staticRenderFns } from "./SearchCorp.vue?vue&type=template&id=2878a1f2&scoped=true&"
import script from "./SearchCorp.vue?vue&type=script&lang=js&"
export * from "./SearchCorp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2878a1f2",
  null
  
)

export default component.exports